import React from 'react';
import { withTranslation } from 'react-i18next';

class NotAuthorizedComponent extends React.Component {
    render() { 
        return (<div>Not authorized</div>)
    }
}
export default withTranslation("translation")(NotAuthorizedComponent);
